import React, { useState, useRef, useEffect } from "react";

interface FilterState {
    status?: string;
}

interface YourRequestFilterProps {
    onClose: () => void;
    onFilterChange: (filters: FilterState) => void;
    activeFilters: FilterState; // Add this prop to receive the current filters
}

const YourRequestFilter: React.FC<YourRequestFilterProps> = ({ 
    onClose, 
    onFilterChange, 
    activeFilters 
}) => {
    // Initialize with the active filters
    const [filters, setFilters] = useState<FilterState>(activeFilters);
    const filterRef = useRef<HTMLDivElement | null>(null);

    // Update local state when activeFilters prop changes
    useEffect(() => {
        setFilters(activeFilters);
    }, [activeFilters]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (filterRef.current && !filterRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const handleInputChange = (field: keyof FilterState, value: string) => {
        const newFilters = { ...filters, [field]: value };
        setFilters(newFilters);
    };

    const clearAllFilters = () => {
        const clearedFilters = { status: "" };
        setFilters(clearedFilters);
        onFilterChange(clearedFilters);
    };

    return (
        <div
            ref={filterRef}
            className="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow !right-0 !left-auto !mt-2 !transform-none !top-full sm:w-96 w-full"
            style={{
                position: "absolute",
                inset: "0px auto auto 0px",
                margin: "0px",
                transform: "translate3d(-18.4px, 56px, 0px)",
            }}
        >
            <ul className="px-3 text-sm text-gray-700" aria-labelledby="dropdownDefaultButton-3">
                <div className="flex items-center justify-between pt-3 mx-3 rounded-t border-b border-lightgray-100 pb-4">
                    <h3 className="text-base font-semibold text-grease-100">Filters</h3>
                    {/* <button
                        type="button"
                        onClick={onClose}
                        className="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    >
                        <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                            />
                        </svg>
                        <span className="sr-only">Close dropdown</span>
                    </button> */}
                </div>

                {/* Status */}
                <div className="bg-indigo-200 bg-opacity-25 rounded-lg mt-4 p-4 mx-3 mb-4 border-b border-lightgray-100">
                    <p className="text-sm">Select Status</p>
                    <div className="flex sm:flex-nowrap flex-wrap items-center gap-4 mt-3">
                        <div className="w-full">
                            <select
                                value={filters.status || ""}
                                onChange={(e) => handleInputChange("status", e.target.value)}
                                className="block w-full border-none p-3 rounded-lg bg-white text-xs text-grease-100 placeholder-gray-400 focus:outline-none"
                            >
                                <option value="">All</option>
                                <option value="Pending">Pending</option>
                                <option value="Answered">Answered</option>
                                <option value="Expired">Expired</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="flex items-center justify-between mx-3 mb-4">
                    <button onClick={onClose} className="flex gap-2 px-3 py-2 bg-blue-500 bg-opacity-25 rounded-md">
                        <p className="font-medium text-lightgray-200 text-xs">Cancel</p>
                    </button>
                    <div className="flex items-center gap-4">
                        <button onClick={clearAllFilters} className="flex gap-2 px-3 py-2 border border-[#FFBC00] rounded-md">
                            <p className="font-medium text-[#FFBC00] text-xs">Clear All</p>
                        </button>
                        <button onClick={() => onFilterChange(filters)} className="flex gap-2 px-3 py-2 bg-[#FFBC00] rounded-md">
                            <p className="font-medium text-[#F5F9FE] text-xs">Apply</p>
                        </button>
                    </div>
                </div>
            </ul>
        </div>
    );
};

export default YourRequestFilter;